import React from "react";
import { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useGlobalContext } from "../../context";
import api from "../../api";
import UserSideNav from "../components/UserSideNav";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { FiCopy, FiCheck } from "react-icons/fi";
import { BiLogOut, BiSolidWallet } from "react-icons/bi";
import userDashLinks from "./userDashLinks";
import { BsChevronDown } from "react-icons/bs";
import { FaBitcoin, FaEthereum } from "react-icons/fa";
import { BiSolidDollarCircle } from "react-icons/bi";
import btcwalletImage from "../../images/btcwallet.jpg";
import ethwalletImage from "../../images/ethwallet.jpg";
import solwalletImage from "../../images/solwallet.jpg";

const cryptoOptions = [
  {
    key: "BTC",
    label: "BTC",
    icon: <FaBitcoin className="text-yellow-500 shrink-0" />,
    address: process.env.REACT_APP_BTC_ADDRESS,
    image: btcwalletImage,
  },
  {
    key: "ETH",
    label: "ETH",
    icon: <FaEthereum className="text-blue-400 shrink-0" />,
    address: process.env.REACT_APP_ETH_ADDRESS,
    image: ethwalletImage,
  },
  {
    key: "USDT",
    label: "USDT (ERC20)",
    icon: <BiSolidDollarCircle className="text-[#868e98] shrink-0" />,
    address: process.env.REACT_APP_ETH_ADDRESS,
    image: ethwalletImage,
  },
  {
    key: "SOL",
    label: "SOL",
    icon: <span className="text-[#9945FF] text-[14px] font-bold shrink-0">◎</span>,
    address: process.env.REACT_APP_SOL_ADDRESS,
    image: solwalletImage,
  },
];

const UserDeposit = () => {
  const { allUserMongoData } = useGlobalContext();

  const [navActive, updateNavActive] = useState(null);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const clearSess = async () => {
    try {
      await api.post("/api/logout");
    } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => {
    updateNavActive(false);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("BTC");
  const [showCopy, UpdateshowCopy] = useState(false);

  const selected = cryptoOptions.find((o) => o.key === selectedCrypto);

  const copyFunc = () => {
    UpdateshowCopy(true);
    setTimeout(() => UpdateshowCopy(false), 2000);
  };

  return (
    <div className="absolute overflow-hidden w-full min-h-full text-white bg-black">
      <UserSideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={
          navActive ? `translate-x-[0px]` : `translate-x-[-500px]`
        }
        clearSess={clearSess}
        backgroundColor="bg-black"
        arrowCoLor="text-white"
        iconBorderColor="border-white"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={userDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1] " />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full p-4 overflow-hidden mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button
              onClick={() => updateNavActive(true)}
              className="relative xl:hidden"
            >
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>

            <div className="relative flex space-x-2">
              <div className="relative flex justify-center items-center space-x-2 min-h-[38px] py-2 px-4 bg-[#181C26] border border-[#1f2535] rounded-lg transition-all ease-in duration-200 hover:border-[#473ECD]">
                <BiSolidWallet className="text-[14px] text-[#A9ABAD]" />
                <p className="text-[12px] text-[#A9ABAD]">
                  $
                  {allUserMongoData && allUserMongoData.balance
                    ? allUserMongoData.balance.toLocaleString()
                    : "0"}
                </p>
              </div>
            </div>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Deposit Funds</h3>
          <p className="text-[#A9ABAD] text-[14px]">
            Send crypto to the address below to fund your account.
          </p>
        </div>

        {/* tab switcher */}
        <div className="flex items-center space-x-1 mb-8 bg-[#181C26] border border-[#1f2535] rounded-lg p-1 w-fit">
          <div className="px-5 py-2 rounded-md text-[13px] text-white bg-[#0d1017]">
            Deposit
          </div>
          <Link
            to="/user/transfer"
            className="px-5 py-2 rounded-md text-[13px] text-[#A9ABAD] hover:text-white transition-colors"
          >
            Transfer
          </Link>
        </div>

        <div className="w-full flex flex-col space-y-4 sm:w-[420px]">
          {/* QR code */}
          <div className="w-full h-[260px] bg-[#181C26] border border-[#1f2535] rounded-xl p-4 sm:w-[420px]">
            <img
              src={selected.image}
              className="max-w-full max-h-full object-contain mx-auto block rounded-lg"
              alt="wallet QR"
              loading="lazy"
            />
          </div>

          {/* details card */}
          <div className="w-full bg-[#181C26] border border-[#1f2535] rounded-xl p-6 flex flex-col">
            {/* asset selector */}
            <div className="w-full flex flex-col space-y-2 pb-5">
              <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
                Asset
              </label>
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setIsOpen(!isOpen)}
                  className="w-full flex justify-between items-center bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 py-3 text-[13px] text-white"
                >
                  <div className="flex items-center space-x-2">
                    {selected.icon}
                    <span>{selected.label}</span>
                  </div>
                  <BsChevronDown
                    className={`text-[#A9ABAD] text-[13px] transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isOpen && (
                  <ul className="absolute top-[calc(100%+4px)] left-0 w-full z-50 bg-[#0d1017] border border-[#1f2535] rounded-lg overflow-hidden">
                    {cryptoOptions.map((opt) => (
                      <li
                        key={opt.key}
                        onClick={() => {
                          setSelectedCrypto(opt.key);
                          setIsOpen(false);
                        }}
                        className="flex items-center space-x-2 px-4 py-3 text-[13px] text-[#A9ABAD] hover:bg-[#181C26] hover:text-white cursor-pointer transition-colors"
                      >
                        {opt.icon}
                        <span>{opt.label}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="w-full h-[1px] bg-[#1f2535]" />

            {/* wallet address */}
            <div className="w-full flex flex-col space-y-2 pt-5">
              <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
                Wallet Address
              </label>
              <div className="w-full flex items-center justify-between bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 py-3 gap-3">
                <p className="text-[13px] text-white truncate">
                  {selected.address}
                </p>
                <FiCopy className="text-[#A9ABAD] text-[15px] flex-shrink-0" />
              </div>
            </div>
          </div>

          {/* copy button */}
          <CopyToClipboard onCopy={copyFunc} text={selected.address}>
            <button className="w-full min-h-[44px] flex justify-center items-center space-x-2 text-[14px] font-[500] bg-userDashPurple rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5]">
              {showCopy ? (
                <>
                  <FiCheck className="text-white text-[15px]" />
                  <span>Copied!</span>
                </>
              ) : (
                <>
                  <FiCopy className="text-white text-[15px]" />
                  <span>Copy Address</span>
                </>
              )}
            </button>
          </CopyToClipboard>

          {showCopy && (
            <div className="w-full px-4 py-3 bg-[#181C26] border border-[#1f2535] rounded-lg flex items-center justify-between gap-3">
              <p className="text-[12px] text-[#A9ABAD] whitespace-nowrap">
                Copied
              </p>
              <p className="text-[12px] text-[#535963] truncate">
                {selected.address}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDeposit;
